'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAvailable = undefined;

var _isAgentState = require('./isAgentState');

var _AgentStates = require('../../constants/AgentStates');

var isAvailable = exports.isAvailable = (0, _isAgentState.isAgentState)(_AgentStates.AVAILABLE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/agent-state/isAvailable.js
// module id = 630
// module chunks = 2 3